import { ReactElement } from 'react'

import { Container } from '@mui/material'
import { useTranslation, Trans } from 'react-i18next'

import GoogleIcon from 'public/images/google.svg'
import FacebookIcon from 'public/images/facebook.svg'
import ModalHeader from '@/components/molecules/ModalHeader'
//import MicrosoftIcon from 'public/images/microsoft.svg'
import { SOCIAL_NETWORKS_IDS } from '@/config/constants'

import ComponentStyled from './styled'

type SocialItemProps = {
  id: string
  name: string
  icon: ReactElement
  onConfirm: (id: string) => void
}

const SocialItem = ({ id, name, icon, onConfirm }: SocialItemProps) => {
  return (
    <div className='social-item' onClick={() => onConfirm(id)}>
      <p className='social-item-copy'>
        {icon}
        <span>{name}</span>
      </p>
    </div>
  )
}

type Props = {
  onConfirm: (socialId: string) => void
}

const SocialForm = ({ onConfirm }: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <ComponentStyled>
      <Container maxWidth='xl'>
        <div className='social-box'>
          <ModalHeader prepend={t('Plant your wish')} />
          <div className='social-content'>
            <p className='social-title'>{t('Spread the word to reach our 100 year goal!')}</p>
            <p className='social-desc'>
              <Trans i18nKey='Loggin to your social profile to fight for the biodiersity. How so? Because we want to be sure that you are a real person, not a bot :)'>
                Loggin to your social profile to fight for the biodiersity. <strong>How so?</strong> Because we want to
                be sure that you are a real person, not a bot :)
              </Trans>
            </p>

            <div className='social-items-wrapper'>
              <SocialItem onConfirm={onConfirm} id={SOCIAL_NETWORKS_IDS.GOOGLE} name='Google' icon={<GoogleIcon />} />
              <SocialItem
                onConfirm={onConfirm}
                id={SOCIAL_NETWORKS_IDS.FACEBOOK}
                name='Facebook'
                icon={<FacebookIcon />}
              />
              {/*<SocialItem
                onConfirm={onConfirm}
                id={SOCIAL_NETWORKS_IDS.MICROSOFT}
                name='Microsoft'
                icon={<MicrosoftIcon />}
              />*/}
            </div>
          </div>
        </div>
      </Container>
    </ComponentStyled>
  )
}

export default SocialForm
